import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageRequest } from 'src/app/shared/model/page/page-request';
import { PageResult } from 'src/app/shared/model/page/page-result';
import { HttpUtils } from 'src/app/shared/services/common/http-utils';
import { BaseFilter } from 'src/app/shared/model/filter/base-filter';
import { Locality } from 'src/app/shared/model/locality';

@Injectable({
  providedIn: 'root',
})
export class LocalityService {

  constructor(private readonly http: HttpClient) { }

  findLocalities(countryCode: string, countyCode: string, filter: BaseFilter, pageRequest: PageRequest): Observable<PageResult<Locality>> {
    const queryParams = {
      countyCode: countyCode || ''
    };
    const httpParams = HttpUtils.createHttpParams(queryParams, filter, pageRequest);
    return this.http.get<PageResult<Locality>>(`api/countries/${countryCode}/localities`, { params: httpParams });
  }

}
